export const RenglonesPersonasOptions = [
    {text: 'Personal permanente - 011', value:'011'},   
    {text: 'Personal supernumerario - 021', value: '021'},
    {text: 'Personal por contrato - 022', value: '022'},  
    {text: 'Otras remuneraciones de personal temporal - 029', value: '029'},
    {text: 'Jornales - 031', value: '031'},
   
    {text: 'Estudios, investigaciones y proyectos de factibilidad - 181', value: '181'},
    {text: 'Servicios médico-sanitarios - 182', value: '182'},
    {text: 'Servicios jurídicos - 183', value: '183'},
    {text: 'Servicios económicos, contables y de auditoria - 184', value: '184'},
    {text: 'Servicios de capacitación - 185', value: '185'},
    {text: 'Servicios de informática y sistemas computarizados -186', value: '186'},
    {text: 'Servicios por actuaciones artísticas y deportivas - 187', value: '187'},
    {text: 'Servicios de ingeniería, arquitectura y supervisión de obras - 188', value: '188'},
    {text: 'Otros estudios y/o servicios - 189', value: '189'},
]